var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4372 2C17.092 2 17.7196 2.26142 18.178 2.72342L21.2789 5.82432C21.7406 6.286 21.9999 6.91217 21.9999 7.56508C21.9999 8.21799 21.7406 8.84416 21.2789 9.30584L9.95739 20.6238C9.2589 21.4295 8.26878 21.9245 7.13448 22.0023H1.99988V21.0023L2.00313 16.7873C2.08832 15.7328 2.57854 14.7523 3.32637 14.0934L14.6953 2.72463C15.1563 2.26083 15.7832 2 16.4372 2ZM7.06386 20.0048C7.59808 19.967 8.09537 19.7184 8.49467 19.2616L16.0566 11.6997L12.3022 7.94519L4.69598 15.5496C4.29083 15.9079 4.04019 16.4092 3.99988 16.8678V20.0029L7.06386 20.0048ZM13.7166 6.53115L17.4708 10.2855L19.8647 7.89162C19.9513 7.80502 19.9999 7.68756 19.9999 7.56508C19.9999 7.4426 19.9513 7.32514 19.8647 7.23854L16.761 4.13486C16.6754 4.04855 16.5588 4 16.4372 4C16.3156 4 16.1991 4.04855 16.1135 4.13486L13.7166 6.53115Z",
    fill: "#4F34D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e2df8fbb265090f8a2a6f419ed8c4b49.svg";
export { ForwardRef as ReactComponent };